<template>
  <router-view :key="Date.now()" />
</template>

<script>

export default {
  data () {
    return {}
  }
}
</script>
<style>
 body {
    background: white;  
}
</style>
